import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'aw-action-bar-layout',
  templateUrl: './action-bar-layout.component.html',
  styleUrls: ['./action-bar-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.action-bar-layout--compact]': 'compact()',
    '[class.action-bar-layout--stackable]': 'stackable()'
  }
})
export class ActionBarLayoutComponent {
  /** Strips the fixed height and padding from the layout */
  readonly compact = input(false)

  /** Stacks the left and right sections onto two rows when the width gets narrow */
  readonly stackable = input(false)
}
